import CollectorDonationView from "./CollectorDonationView";
export default CollectorDonationView;
